import * as React from 'react';
import { useCookies } from 'react-cookie';
import { ClientPersistInterface } from 'Interfaces/ClientPersistInterface';
import { FormInterface } from 'Interfaces/Forms/FormsInterface';
import { LocationInterface } from 'Interfaces/LocationInterface';
import { getLocalization } from 'global/global';
import { useAppDispatch } from 'index';
import { loginUserSuccess } from 'actions/userActions';
import { loadLocations } from 'actions/locationsActions';
import { sortObjects } from 'utils/utils';
import { getExpiryDate } from 'utils/cookies';
import { loadForms } from 'actions/formsActions';
import { registerPasskey } from 'actions/passKeysActions';
import { ConfirmationModal } from '../ConfirmationModal';

interface PassKeysModalProps {
  responseData: ClientPersistInterface;
  questionnaireList?: FormInterface[];
  locationsList?: LocationInterface[];
  onClose: () => void;
}

export default function PassKeysModal(props: PassKeysModalProps) {

  const dispatch = useAppDispatch();

  const [cookie, setCookie] = useCookies(['pm-passkey']);

  React.useEffect(() => {
    console.info('placeholder effect');
  }, [cookie]);

  const addPassKeys = async () => {
    props.onClose();
    const response = await dispatch(registerPasskey());
    if (response.ok) {
      loginUser();
    }
  };

  const loginUser = (cancel?: boolean) => {
    if (props.responseData) {
      dispatch(loginUserSuccess(props.responseData));
      if (props.questionnaireList) {
        dispatch(loadForms({
          forms: props.questionnaireList.map((f) => {
            f.ref = f.id;
            return f;
          })
        }));
      }
      if (props.locationsList) {
        dispatch(loadLocations(props.locationsList.sort((a, b) => sortObjects(a, b, 'title'))));
      }
      if (cancel) {
        setCookie('pm-passkey', 'true', { expires: getExpiryDate(7) });
      }
    }
    props.onClose();
  };

  const body = (
    <p>{getLocalization('addPassKeysPrompt')}</p>
  );

  return (
    <ConfirmationModal
      onConfirm={() => void addPassKeys()}
      onClose={() => loginUser(true)}
      localizations={{
        cancel: getLocalization('notNow'),
        confirm: getLocalization('createPassKey'),
        confirmStyle: 'success',
        header: (
          <label>{getLocalization('addPassKey')}</label>
        ),
        body: (body)
      }}
    />
  );
}
